/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{nativeArrayMaxSize as r}from"../../core/typedArrayUtil.js";function n(n,e=!1){return n<=r?e?new Array(n).fill(0):new Array(n):new Uint32Array(n)}function e(r,n,e){return Array.isArray(r)?r.slice(n,n+e):r.subarray(n,n+e)}export{n as newUintArray,e as uintSubArray};
